var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('x-tabs',{attrs:{"titles":_vm.titles,"components":_vm.components}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }